export default "__VITE_ASSET__C12O7o$d__"